import React from 'react';
import styled from 'styled-components';

import Nav from '../../Components/Custom/ES/Nav';
import SliderSection from '../../Components/Custom/ES/SliderSection';
import AboutUs from '../../Components/Custom/ES/About';
import OurPrint from '../../Components/Custom/ES/OurVisualPrint';
import LogoContainer from '../../Components/Custom/ES/LogosContainer';
import Footer from '../../Components/Custom/ES/Footer';
import GlobalModals from '../../Components/Custom/ES/Modals';
import ScrollToTopButton from '../../Components/Global/ScrollToTop';

import Bacground from '../../Images/background/full_bg.png';
import MainBg from '../../Images/background/full_site_bg.png';
import MainBgMob from '../../Images/background/home_bg-mob.png';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const MainContainer = styled.div`
  background-image: url(${MainBg});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top center;

  @media (max-width: ${breakpoints.tablet}) {
    background-size: cover;
  }

  @media (max-width: ${breakpoints.mobile}) {
    background-image: url(${MainBgMob});
    background-size: 100%;
  }
`;

const SubContainer = styled.div`
  .container {
    max-width: 350px;
    width: 100%;

    margin: 0 auto;

    @media (min-width: ${breakpoints.tablet}) {
      max-width: 900px;
    }

    @media (min-width: ${breakpoints.desktop}) {
      max-width: 1300px;
    }
  }
`;

const Home = () => {
  return (
    <>
      <MainContainer className="main-container">
        <Nav />
        <SubContainer id="info-kuter">
          <SliderSection />
          <AboutUs />
          <OurPrint />
          <LogoContainer />
          <Footer />
        </SubContainer>

        <ScrollToTopButton />
      </MainContainer>
      <GlobalModals />
    </>
  );
};

export default Home;
